export default __webpack_public_path__ + "static/media/asUSDC.2b9ae873.png";